import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=55616ff3&"
import script from "./AddBrand.vue?vue&type=script&lang=ts&"
export * from "./AddBrand.vue?vue&type=script&lang=ts&"
import style0 from "./AddBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports